import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter } from 'react-router';

import { Button, Card, CardActions, Step, StepLabel, Stepper, Typography } from '@mui/material';
import CardContent from '@mui/material/CardContent';

import Footer from 'main/components/Footer';
import Utils from 'utils/Utils';

import Configure from './wizard/Configure';
import Demo from './wizard/Demo';
import Install from './wizard/Install';
import OS from './wizard/OS';
import Results from './wizard/Results';
import Heading from "main/components/Heading";

@withRouter
@inject('scanWizardStore')
@observer
export default class Wizard extends React.Component {
    static getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return <OS />;
            case 1:
                return <Install />;
            case 2:
                return <Configure />;
            case 3:
                return <Results />;
        }
    }

    render() {
        const { osType, stepIndex, next, prev } = this.props.scanWizardStore;

        const isMobile = Utils.isMobile();

        return (
            <div style={{ padding: isMobile ? '0 20px' : '0 48px', marginBottom: 100 }}>
                <Heading text="Agent Scanner" />

                <Demo />

                <Card>

                    <CardContent>
                        <div className="vulners-stepper">
                            <Stepper activeStep={stepIndex}>
                                <Step>
                                    <StepLabel>OS</StepLabel>
                                </Step>
                                <Step>
                                    <StepLabel>Install package</StepLabel>
                                </Step>
                                <Step>
                                    <StepLabel>Configure agent</StepLabel>
                                </Step>
                                <Step>
                                    <StepLabel>Review results</StepLabel>
                                </Step>
                            </Stepper>
                        </div>

                        <div style={{ padding: isMobile ? 0 : 24 }}>{Wizard.getStepContent(stepIndex)}</div>
                    </CardContent>

                    <CardActions style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}>
                        {
                            <Button
                                disabled={stepIndex === 0}
                                color="primary"
                                variant="outlined"
                                onClick={prev}
                                style={{ marginRight: 8 }}
                            >
                                Back
                            </Button>
                        }
                        {stepIndex === 3 ? (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => this.props.history.push('/linux-scanner')}
                            >
                                To My Scans
                            </Button>
                        ) : (
                            osType && (
                                <Button color="primary" variant="contained" onClick={next}>
                                    Next
                                </Button>
                            )
                        )}
                    </CardActions>
                </Card>

                <Footer />
            </div>
        );
    }
}
